import DeviceManager from '../utils/device-manager';
import $ from "jquery";

class RelatedProductsSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
            direction: 'horizontal',
            loop: false,
            freeMode: true,
            slidesPerView: "auto",
            slideToClickedSlide: true,
            breakpoints: {
                1200: {
                    spaceBetween: 80,
                },
                768: {
                    spaceBetween: 50,
                },
                320: {
                    spaceBetween: 30,
                }
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: 200,
            }
		};

		if (this.$el.length) {
			this._init();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.product');
        this.slidesCount = this.$slides.length;

        // console.log('Nombre de slides related products: ' + this.slidesCount);

        if (document.body.clientWidth < 700 && this.slidesCount > 1) {
            this.slider = new Swiper(this.$el[0], this.options);
            // console.log('slider mobile');
        } else if (document.body.clientWidth >= 700 && document.body.clientWidth < 1200 && this.slidesCount > 2) {
            this.slider = new Swiper(this.$el[0], this.options);
            // console.log('slider tablet');
        } else if (document.body.clientWidth >= 1200 && document.body.clientWidth < 1400 && this.slidesCount > 3) {
            this.slider = new Swiper(this.$el[0], this.options);
            // console.log('slider desktop');
        } else if (document.body.clientWidth >= 1400 && this.slidesCount > 4) {
            this.slider = new Swiper(this.$el[0], this.options);
            // console.log('slider medium-large desktop +1400');
        } else {
            // console.log('no related products slider');
        } 
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy(true,true);
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if (document.body.clientWidth < 700 && this.slidesCount > 1) {
            this._destroy();
            this.slider = new Swiper(this.$el[0], this.options);
            // console.log('slider resize mobile');
        } else if (document.body.clientWidth >= 700 && document.body.clientWidth < 1200 && this.slidesCount > 2) {
            this._destroy();
            this.slider = new Swiper(this.$el[0], this.options);
            // console.log('slider resize tablet');
        } else if (document.body.clientWidth >= 1200 && document.body.clientWidth < 1400 && this.slidesCount > 3) {
            this._destroy();
            this.slider = new Swiper(this.$el[0], this.options);
            // console.log('slider resize desktop');
        } else if (document.body.clientWidth >= 1400 && this.slidesCount > 4) {
            this._destroy();
            this.slider = new Swiper(this.$el[0], this.options);
            // console.log('slider resize medium-large desktop +1400');
        } else {
            this._destroy();
            // console.log('no related products slider');
        }
    }

}

export default RelatedProductsSlider;
